import enviro from 'enviro';
import { isUnloadAlertDisabled } from '../selenium/seleniumFeatures';
import { Tracker } from '../store/tracking/action-creators';
import { Step } from '../views/Step';
export const alertBeforeUnload = dispatch => {
  const onVisibilityChange = function onVisibilityChange() {
    if (document.visibilityState === 'hidden') {
      dispatch(Tracker.leavePage('leave-page'));
    }
  };

  const addAlert = () => {
    if (!enviro.deployed() || isUnloadAlertDisabled()) {
      return;
    }

    window.onbeforeunload = function () {
      dispatch(Tracker.leavePage('tried-to-leave-page'));
      return '';
    };

    window.addEventListener('visibilitychange', onVisibilityChange, false);
  };

  const removeAlert = () => {
    window.onbeforeunload = null;
    window.removeEventListener('visibilitychange', onVisibilityChange, false);
  };

  return {
    addAlert,
    removeAlert
  };
};
export const stepsWithNoAlert = [Step.Verification, Step.ResendEmail, Step.WordpressAuthorization, Step.IntegrationsAccountCreated];